import { connection } from "../../config";
import { getData } from "../../utils/commons";
import { httpUtil } from "./httpUtil";
import { createCommonResult, createResult, ErrorCodes } from "./resultUtil";

export const config = {
    getAppCfg,
    getQueues,
    getListServiceRequests,
    createServiceRequest,
    uploadFilesNew,
    uploadAttachmentContact,
    getDetailFile,
}


async function getAppCfg(applicationID, cloundName) {
    try {
        var app_id = await getData("APP_ID");
        if (!app_id) {
            app_id = applicationID;
        }
        var queryParams = {}
        if (app_id) {
            queryParams.platform_app_id = app_id;
        }
        else {
            queryParams.cloud_name = cloundName;
        }
        //console.log('API: ', contact)
        let response = await httpUtil.get({
            resourcePath: connection.newApiFlow ? '/v2/applications' : '/v1/applications',
            queryParams: queryParams,
            logOutIfSessionInvalid: false
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getIndustries: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getQueues({
    state_for_self_service = 'ENABLED',
    state = 'DISABLED',
} = {},) {
    try {
        let response = await httpUtil.get({
            resourcePath: '/v1/queues',
            queryParams: {
                state_for_self_service,
                state,
            }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getIndustries: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getListServiceRequests({
    state = null,
} = {},) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.get({
            resourcePath: '/v1/contacts/' + id + '/service_requests/',
            queryParams: {
                state,
            }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getIndustries: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function createServiceRequest({
    description,
    queue_id,
}) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.post({
            resourcePath: '/v1/contacts/' + id + '/service_requests/',
            body: {
                description,
                queue_id,
            },
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception addDevice: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function uploadFilesNew({
    file,
    token,
} = {}) {
    try {
        let response = await httpUtil.uploadFileNew({
            resourcePath: "/v1/upload/files",
            fileData: file,
            body: {},
            withAccessToken: false,
            token: token,
        });
        //check return code here instead of put as there would be different intepretation for different API
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            createResult(ErrorCodes.UNKNOWN, response.error);
        }
    } catch (e) {
        console.log("Exception uploadFiles: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function uploadAttachmentContact(file_id) {
    try {
        let contact_id = httpUtil.getSession().sub;
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/" + contact_id + "/files",
            body: {
                id: file_id,
            },
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            createResult(ErrorCodes.UNKNOWN, response.error);
        }
    } catch (e) {
        console.log("Exception uploadAttachmentContact: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getDetailFile(file_id) {
  try {
    let response = await httpUtil.get({
      resourcePath: '/v1/files/' + file_id,
      withAccessToken: true,
      returnBlob:true
    });
    //check return code here instead of put as there would be different intepretation for different API
    return createCommonResult(response);
  } catch (e) {
    console.log('Exception getDetailFile: ', e);
    return createResult(ErrorCodes.UNKNOWN, e);
  }
}